import {
  createSlice,
  createSelector,
  createAsyncThunk,
} from "@reduxjs/toolkit";

import { errorSnack } from "../snackbar/snackbarSlice";

import axios from "axios";

const baseURL = process.env.REACT_APP_API_URL;

export const fetchProductsOrdered = createAsyncThunk(
  "reports/fetchProductsOrdered",
  async (args, thunkAPI) => {
    try {
      const config = {
        headers: { Authorization: `Bearer ${args.token}` },
      };
      const response = await axios.get(
        `${baseURL}/v1/admin/reports/products_ordered${args.query}`,
        config
      );
      thunkAPI.dispatch(setLastQuery(args.query));
      thunkAPI.dispatch(
        setProductsOrderedAmount(response.headers["x-total-count"])
      );
      return await response.data;
    } catch (error) {
      if (error.response && error.response.data) {
        thunkAPI.dispatch(
          errorSnack(
            error.response.data.error_description ||
              "Error fetching Stores list"
          )
        );
      }
      return thunkAPI.rejectWithValue({ error: error.message });
    }
  }
);

export const fetchMoreProductsOrdered = createAsyncThunk(
  "reports/fetchMoreProductsOrdered",
  async (args, thunkAPI) => {
    try {
      const config = {
        headers: { Authorization: `Bearer ${args.token}` },
      };
      const response = await axios.get(
        `${baseURL}/v1/admin/reports/products_ordered${args.query}&offset=${args.offset}`,
        config
      );

      // thunkAPI.dispatch(setLastQuery(args.query));
      thunkAPI.dispatch(
        setProductsOrderedAmount(response.headers["x-total-count"])
      );

      return await response.data;
    } catch (error) {
      if (error.message.includes("401")) {
        localStorage.removeItem("coreUser");
        localStorage.removeItem("coreToken");
      }
      if (error.response && error.response.data) {
        // thunkAPI.dispatch(
        //   errorSnack(
        //     error.response.data.error_description ||
        //       'Error fetching products list'
        //   )
        // );
      }
      return thunkAPI.rejectWithValue({ error: error.message });
    }
  }
);

export const fetchAverageMargin = createAsyncThunk(
  "reports/fetchAverageMargin",
  async (args, thunkAPI) => {
    try {
      const config = {
        headers: { Authorization: `Bearer ${args.token}` },
      };
      const response = await axios.get(
        `${baseURL}/v1/admin/reports/average_margin${args.query}`,
        config
      );
      return await response.data;
    } catch (error) {
      if (error.response && error.response.data) {
        thunkAPI.dispatch(
          errorSnack(
            error.response.data.error_description ||
              "Error fetching Stores list"
          )
        );
      }
      return thunkAPI.rejectWithValue({ error: error.message });
    }
  }
);

export const fetchMoreAverageMargin = createAsyncThunk(
  "reports/fetchMoreAverageMargin",
  async (args, thunkAPI) => {
    try {
      const config = {
        headers: { Authorization: `Bearer ${args.token}` },
      };
      const response = await axios.get(
        `${baseURL}/v1/admin/reports/average_margin${args.query}&offset=${args.offset}`,
        config
      );

      // thunkAPI.dispatch(setLastQuery(args.query));
      thunkAPI.dispatch(
        setAverageMarginAmount(response.headers["x-total-count"])
      );

      return await response.data;
    } catch (error) {
      if (error.message.includes("401")) {
        localStorage.removeItem("coreUser");
        localStorage.removeItem("coreToken");
      }
      if (error.response && error.response.data) {
        // thunkAPI.dispatch(
        //   errorSnack(
        //     error.response.data.error_description ||
        //       'Error fetching products list'
        //   )
        // );
      }
      return thunkAPI.rejectWithValue({ error: error.message });
    }
  }
);

export const getFullListProductsOrdered = createAsyncThunk(
  "products/getFullListProductsOrdered",
  async (args, thunkAPI) => {
    let objToMap = [];
    for (let i = 0; i < (args.targetLength - args.offset) / 100; i++) {
      objToMap.push({
        token: args.token,
        query: args.query,
        offset: args.offset + 100 * i,
      });
    }

    Promise.all(
      objToMap.map((requestData) =>
        thunkAPI.dispatch(fetchMoreProductsOrdered(requestData))
      )
    )
      .then((results) => {})
      .catch((err) => {
        return thunkAPI.rejectWithValue("Error fetching full product list");
      });
  }
);

export const getFullListAverageMargin = createAsyncThunk(
  "products/getFullListAverageMargin",
  async (args, thunkAPI) => {
    let objToMap = [];
    for (let i = 0; i < (args.targetLength - args.offset) / 100; i++) {
      objToMap.push({
        token: args.token,
        query: args.query,
        offset: args.offset + 100 * i,
      });
    }

    Promise.all(
      objToMap.map((requestData) =>
        thunkAPI.dispatch(fetchMoreAverageMargin(requestData))
      )
    )
      .then((results) => {})
      .catch((err) => {
        return thunkAPI.rejectWithValue("Error fetching full product list");
      });
  }
);

const reportsSlice = createSlice({
  name: "reports",
  initialState: {
    reportList: [],
    loading: "idle",
    message: "",
    error: "",
    productsOrderedAmount: "",
    averageMarginAmount: "",
    lastQuery: "",
  },
  reducers: {
    setLastQuery: (state, action) => {
      state.lastQuery = action.payload;
    },
    setProductsOrderedAmount: (state, action) => {
      state.productsOrderedAmount = action.payload;
    },
    setAverageMarginAmount: (state, action) => {
      state.averageMarginAmount = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(fetchProductsOrdered.pending, (state) => {
      state.reportList = [];
      state.loading = "loading";
      state.editing = false;
    });
    builder.addCase(fetchProductsOrdered.fulfilled, (state, { payload }) => {
      state.reportList = payload;
      state.loading = "loaded";
    });
    builder.addCase(fetchProductsOrdered.rejected, (state, action) => {
      state.loading = "error";
      state.error = action.error;
    });
    builder.addCase(
      fetchMoreProductsOrdered.fulfilled,
      (state, { payload }) => {
        state.error = "";
        state.reportList = state.reportList.concat(payload);
        state.loading = "loaded";
      }
    );
    builder.addCase(fetchMoreProductsOrdered.rejected, (state, action) => {
      state.loading = "error";
      state.error = action.error.message;
    });
    builder.addCase(
      getFullListProductsOrdered.fulfilled,
      (state, { payload }) => {
        state.error = "";
        state.reportList = state.reportList.sort(function (a, b) {
          return a.id - b.id;
        });
        state.loading = "loaded";
      }
    );
    builder.addCase(getFullListProductsOrdered.rejected, (state, action) => {
      state.loading = "error";
      state.error = action.error.message;
    });
    builder.addCase(fetchAverageMargin.pending, (state) => {
      state.reportList = [];
      state.loading = "loading";
      state.editing = false;
    });
    builder.addCase(fetchAverageMargin.fulfilled, (state, { payload }) => {
      state.reportList = payload;
      state.loading = "loaded";
    });
    builder.addCase(fetchAverageMargin.rejected, (state, action) => {
      state.loading = "error";
      state.error = action.error;
    });
    builder.addCase(fetchMoreAverageMargin.fulfilled, (state, { payload }) => {
      state.error = "";
      state.reportList = state.reportList.concat(payload);
      state.loading = "loaded";
    });
    builder.addCase(fetchMoreAverageMargin.rejected, (state, action) => {
      state.loading = "error";
      state.error = action.error.message;
    });
    builder.addCase(
      getFullListAverageMargin.fulfilled,
      (state, { payload }) => {
        state.error = "";
        state.reportList = state.reportList.sort(function (a, b) {
          return a.id - b.id;
        });
        state.loading = "loaded";
      }
    );
    builder.addCase(getFullListAverageMargin.rejected, (state, action) => {
      state.loading = "error";
      state.error = action.error.message;
    });
  },
});

export const {
  setLastQuery,
  setProductsOrderedAmount,
  setAverageMarginAmount,
} = reportsSlice.actions;

export const selectReports = createSelector(
  (state) => ({
    reportList: state.reports.reportList,
    storesFilter: state.reports.storesFilter,
    loading: state.reports.loading,
    error: state.reports.error,
    productsOrderedAmount: state.reports.productsOrderedAmount,
    averageMarginAmount: state.reports.averageMarginAmount,
    lastQuery: state.reports.lastQuery,
  }),
  (state) => state
);
export default reportsSlice.reducer;
